import React, { Component } from 'react';
import { Button, Col, Row, ModalHeader, ModalBody, ModalFooter, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip,Form,
    FormGroup, Label,} from 'reactstrap';
import { connect } from 'react-redux';
import EWSCounterpartyTable from './Counterparty Table';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { getCorporateName } from '../../Analyst/Cases/List/Actions';
import {
    fetchEwsCounterpartiesRequest,
    fetchFilteredEwsCounterpartiesRequest,
    optInForEwsRequest,
    ewsPlanListRequest,
    counterpartyUploadTemplateRequest,
    counterpartyUploadRequest,
    addEwsPlanRequest,
    fetchCrawlerStatusReportRequest,
    reinitiateFailedCrawlersRequest, 
    getDayOfMonthRequest, 
    updateDayOfMonthRequest,
    runEWSRequest,
    ewsReportDataUploadTemplateRequest,
    ewsReportDataUploadRequest,
    ewsTodoOptinSchedulerRequest,
} from './action';
import Modal from '../../components/UI/Modal/Modal';
import { createFilterUrl,createSecondaryFilterUrl, getUrlFilter, getSecondaryUrlFilter, setAppliedFilters,deleteAppliedFilters, setRequestBody, deleteEntityFilter} from './helper';
import AddUpdatePlanForm from './Add Update Plan';
import fileSaver from 'file-saver';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Preloading } from '../../components/UI/Preloader/action';
import {
    displayErrorMessage,
    displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util'
import { Field, reduxForm } from 'redux-form'
import { right } from 'glamor';
import FilterFormTypeTwo from '../../components/ReusableComponents/FilterFormTypeTwo/index';
import * as constant from '../../Analyst/Cases/List/constants';
class EarlyWarningSystem extends Component {
    constructor(props) {
        super(props);
        this.formOneElement = React.createRef();
        this.state = {
            corporates: [],
            counterparties: [],
            selectedCorporate: null,
            loading: false,
            updatedCounterparties: [],
            ewsOptInResponse: [],
            ewsPlans: [],
            appliedFilters: [],
            selectPlanBody: null,
            selectedPlan: null,
            planModal: false,
            cpUploadModal: false,
            ewsDataUploadModal: false,
            uploadedFile: undefined,
            addPlanResponse: null,
            actionsDropdown: false,
            crawlerStatusResponse: null,
            crawlerStatusModal: false,
            fromDate: null,
            toDate: null,
            reinitiateCrawlerModal: false,
            reinitiateCrawlerResponse: null,
            dayOfMonthModal: null,
            getDayOfMonthResponse: null,
            dayOfMonth: null,
            runEWSResponse: null,
            ewsDataUploadTemplate: null,
            ewsDataUploadResponse: null,
            updateFlag: false,
            todoOptinSchedulerModal: null,
        };
    }

    componentDidMount = () => {
        this.props.getCorporateName();
        this.props.ewsPlanListRequest();
        this.props.getDayOfMonthRequest();
        
        const urlFilters = getUrlFilter(this.props.location.search);
        if (urlFilters.corporate) {
            this.handleCorporateChange(urlFilters.corporate);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.ewsOptInResponse !== this.props.ewsOptInResponse) {    
            this.props.preloading(false);        
            this.setState((prevState) => ({
                updatedCounterparties: [],
            }));
            displaySuccessMessage("Request Submitted Successfully!!");
            this.handleCorporateChange(this.state.selectedCorporate);
        }

        if (prevProps.dayOfMonth !== this.props.dayOfMonth) {            
            this.setState({
                dayOfMonth: this.props.dayOfMonth,
            });
        }

        if (prevProps.corporateNameList !== this.props.corporateNameList) {
            let corporateNames = [];
            this.props.corporateNameList.forEach(item => {
                corporateNames.push({ value: item.id, label: item.name })
            })
            this.setState({
                corporates: corporateNames,
            });
        }

        if (prevProps.ewsPlansList !== this.props.ewsPlansList) {
            let plans = [];
            this.props.ewsPlansList.forEach(item => {
                plans.push({ value: item.id, label: item.planName })
            })

            this.setState({
                ewsPlans: plans,
                selectPlanBody: <div>
                    <Select
                        value={this.state.selectedPlan}
                        onChange={this.handlePlanChange}
                        options={plans}
                        isClearable={false} />
                </div>
            });
        }

        if (prevProps.counterpartyList !== this.props.counterpartyList) {
            let cpList = [];
            if(this.props.counterpartyList){
                this.props.counterpartyList.forEach(item => {
                    item.corporateName = this.state.selectedCorporate.label;
                    cpList.push(item);
                })
            }

            this.setState({
                counterparties: cpList,
                loading: false,
            });
        }

        if (prevProps.counterparties !== this.props.counterparties) {
            this.setState({
                counterparties: this.props.counterparties,
                loading: false,
            })
        }

        if (this.props.cpUploadTemplate !== prevProps.cpUploadTemplate) {
            this.props.preloading(false);
            if (this.props.cpUploadTemplate.status === "SUCCESS") {
                const data = this.props.cpUploadTemplate.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"Counterparty_Upload_Template"}_${moment().format("DD_MMM_YYYY")}.xlsx`);
            } else if (this.props.cpUploadTemplate.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }

        if (this.props.ewsDataUploadResponse !== prevProps.ewsDataUploadResponse) {
            this.props.preloading(false);
            if (this.props.ewsDataUploadResponse.status === "SUCCESS") {                
                let statusCode = this.props.ewsDataUploadResponse.data['status'];
                if(statusCode === 200) {
                    displaySuccessMessage("Data upload done successfully!");
                }else if(statusCode === 204) {
                    displayErrorMessage("No data found in the file to upload!")
                }
                this.toggleEWSReportDataUploadModal();
            } else if (this.props.ewsDataUploadResponse.status === "FAILURE") {
                let errorMessage = this.props.ewsDataUploadResponse.data;
                displayErrorMessage(errorMessage ? errorMessage : "Please Try again !!");
            }
        }

        if (this.props.ewsDataUploadTemplate !== prevProps.ewsDataUploadTemplate) {
            this.props.preloading(false);
            if (this.props.ewsDataUploadTemplate.status === "SUCCESS") {
                const data = this.props.ewsDataUploadTemplate.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"EWS_Report_Data_Upload_Template"}_${moment().format("DD_MMM_YYYY")}.xlsx`);
            } else if (this.props.ewsDataUploadTemplate.status === "FAILURE") {
                displayErrorMessage("Please Try again !!");
            }
        }

        if (this.props.cpUploadResponse !== prevProps.cpUploadResponse) {
            this.props.preloading(false);
            if (this.props.cpUploadResponse.status === "SUCCESS") {
                let statusCode = this.props.cpUploadResponse.data['status'];
                if(statusCode === 200) {
                    const response = this.props.cpUploadResponse.data.data;
                    let blob = new Blob([response], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Counterparty_Upload_Status_Report"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
                    displaySuccessMessage("Counterparties Uploaded Successfully!");
                    this.toggleCPUploadModal();
                    this.handleCorporateChange(this.state.selectedCorporate);
                }else if(statusCode === 204) {
                    displayErrorMessage("No data found in the file to upload!")
                }
            } else {
                let message = this.props.cpUploadResponse.data.message ? this.props.cpUploadResponse.data.message : this.props.cpUploadResponse.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.reinitiateCrawlerResponse !== prevProps.reinitiateCrawlerResponse) {
            this.props.preloading(false);
            if (this.props.reinitiateCrawlerResponse.status === "SUCCESS") {
                displaySuccessMessage("Crawlers Reinitiated Successfully!");
                this.toggleReinitiateCrawlerModal();
            } else {
                let message = this.props.reinitiateCrawlerResponse.data.message ? this.props.reinitiateCrawlerResponse.data.message : this.props.reinitiateCrawlerResponse.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.cpUploadResponse != prevProps.cpUploadResponse) {
            this.props.fetchEwsCounterpartiesRequest(this.state.selectedCorporate.value);
        }

        if (this.props.addPlanResponse !== prevProps.addPlanResponse) {
            if (this.props.addPlanResponse.status === "SUCCESS") {
                displaySuccessMessage("Plan " + (this.state.plan && this.state.plan.id ? "Updated" : "Added") + " Successfully!");
                this.props.ewsPlanListRequest();
            } else {
                let message = this.props.addPlanResponse.data.message ? this.props.addPlanResponse.data.message : this.props.addPlanResponse.data;
                displayErrorMessage(message);
            }
        }

        if (this.props.crawlerStatusResponse !== prevProps.crawlerStatusResponse) {
            this.props.preloading(false);
            if (this.props.crawlerStatusResponse.status === "SUCCESS") {
                let statusCode = this.props.crawlerStatusResponse.data['status'];               
                if(statusCode === 200) {
                    const data = this.props.crawlerStatusResponse.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Crawler_Status_Report"}_${moment().format("DD_MMM_YYYY")}.xlsx`);
                }else if(statusCode === 204) {
                    displayErrorMessage("No crawler status data found!!");
                }            
            } else if (this.props.crawlerStatusResponse.status === "FAILURE") {
                displayErrorMessage("Please try again!!");
            }
        }

        if (this.props.runEWSResponse !== prevProps.runEWSResponse) {
            this.props.preloading(false);
            if (this.props.runEWSResponse.status === "SUCCESS") {
                let statusCode = this.props.runEWSResponse.data['status'];               
                if(statusCode === 200) {
                    displaySuccessMessage("EWS ran successfully !!");
                    this.setState({
                        runEWSResponse: null
                    });
                }else if(statusCode === 204) {
                    displayErrorMessage("No counterparties found to run EWS !!")
                }
            } else if (this.props.runEWSResponse.status === "FAILURE") {
                displayErrorMessage("Please try again !!");
            }
        }
    }

    addEwsPlan = (plan) => {
        this.props.addEwsPlanRequest(plan)
    }

    getFormattedPlan = (planIds) => {
        let tempPlans = this.state.ewsPlans;
        let index = tempPlans.findIndex(p => planIds.includes(p.value));
        return tempPlans[index].label;
    }

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                uploadedFile: file,
            });
        } else {
            this.setState({
                uploadedFile: undefined,
            });
            e.target.value = null;
            this.displayErrorMessage("Please upload Excel File only !");
        }
    }

    displayErrorMessage = (message) => {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
            </div>
        )
    }

    updateSelectedCPsOnMasterPlanChange = (planId) => {
        if (this.state.updatedCounterparties.length > 0) {
            this.state.updatedCounterparties.forEach(cp => {
                let selectPlan = document.getElementById(cp.corporateId + "|" + cp.counterpartyId);
                let options = selectPlan.getElementsByTagName("option");
                if (planId === 'Select plan') {
                    let index = Array.from(options).findIndex(plan => plan.label === 'Select plan');
                    cp.ewsPlans = null;
                    options[index].selected = true;
                } else {
                    Array.from(options).forEach(option => {
                        if (option.value === planId) {
                            cp.ewsPlans = [option.value];
                            option.selected = true;
                        }
                    })
                }
            })
        }
    }

    updateChangedEWSCounterparties = (obj) => {
        let tempList = [...this.state.updatedCounterparties];
        if (obj.length === undefined) {
            let index = tempList.findIndex(cp => (cp.corporateId + "|" + cp.counterpartyId) === (obj.corporateId + "|" + obj.counterpartyId));
            if (index !== -1) {
                let tempObj = tempList[index];
                if (tempObj.ewsOptin === true && obj.ewsOptin === false) {
                    tempList.splice(index, 1);
                } else {
                    tempList[index] = obj;
                }
            } else {
                tempList.push(obj);
            }
            this.setState({
                updatedCounterparties: tempList
            })
        } else {
            this.setState({
                updatedCounterparties: obj
            })
        }
    }

    handleCorporateChange = (selectedData) => {
        this.props.fetchEwsCounterpartiesRequest(selectedData.value);
        this.setState({
            selectedCorporate: selectedData,
            counterparties: this.props.counterparties,
            loading: true,
            updatedCounterparties: []
        })

        const url = createFilterUrl(selectedData);
        this.props.history.push(`?${url}`);
    }

    handlePlanChange = (selectedData) => {
        this.setState({
            selectedPlan: selectedData
        })
    }

    proceedEWSOptIn = () => {
        if (this.validateSelectedPlan()) {
            this.props.optInForEwsRequest(this.state.updatedCounterparties);
            this.props.preloading(true);
        } else {
            displayErrorMessage('Please select plan!!');
        }
    }

    runEWS = () => {        
        this.props.runEWSRequest();
        this.props.preloading(true);
    }

    validateSelectedPlan = () => {
        let index = this.state.updatedCounterparties.findIndex(cp => cp.ewsPlans === null && cp.ewsOptin);
        if (index != -1) {
            return false;
        } else {
            return true;
        }
    }

    openPlanModel = () => {
        this.setState((prevState) => ({
            planModal: !prevState.planModal,
            planModalBody: <AddUpdatePlanForm
                closeModal={this.togglePlanModal}
                planList={this.props.ewsPlansList}
                selectPlanList={this.state.ewsPlans}
                addEwsPlan={this.addEwsPlan}
            />
        }))
    }

    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date
        })
    }

    handleToDateChange = (date) => {
        this.setState({
            toDate: date
        })
    }

    downloadCrawlerStatusReport = () => {
        this.props.preloading(true);
        this.props.fetchCrawlerStatusReportRequest({
            corporateId: this.state.selectedCorporate.value,
            fromDate: moment(this.state.fromDate).format("DD-MM-YYYY"),
            toDate: moment(this.state.toDate).format("DD-MM-YYYY")
        })
        this.toggleCrawlerStatusReportModal();
    }

    handleCounterpartyUpload = (e) => {
        e.preventDefault();
        this.props.counterpartyUploadRequest({
            file: this.state.uploadedFile,
            corporateId: this.state.selectedCorporate.value,
            corporateName: this.state.selectedCorporate.label,
        })
        this.props.preloading(true);
    }

    handleEWSReportDataUpload = (e) => {
        e.preventDefault();
        this.props.ewsReportDataUploadRequest({
            file: this.state.uploadedFile,
        })
        this.props.preloading(true);
    }

    downloadCPUploadTemplate = () => {
        this.props.preloading(true);
        this.props.counterpartyUploadTemplateRequest();
    }

    downloadEWSReportDataUploadTemplate = () => {
        this.props.preloading(true);
        this.props.ewsReportDataUploadTemplateRequest();
    }

    togglePlanModal = () => {
        this.setState((prevState) => ({
            planModal: !prevState.planModal
        }));
    }

    toggleCPUploadModal = () => {
        document.getElementById("upload-cp").value = "";
        this.setState((prevState) => ({
            cpUploadModal: !prevState.cpUploadModal,
            uploadedFile: undefined,
        }));
    }

    toggleEWSReportDataUploadModal = () => {
        document.getElementById("upload-ews-report-data").value = "";
        this.setState((prevState) => ({
            ewsDataUploadModal: !prevState.ewsDataUploadModal,
            uploadedFile: undefined,
        }));
    }

    toggleReinitiateCrawlerModal = () => {
        document.getElementById("reinitiate-crawlers").value = "";
        this.setState((prevState) => ({
            reinitiateCrawlerModal: !prevState.reinitiateCrawlerModal,
            uploadedFile: undefined,
        }));
    }

    handleReinitiateCrawlers = (e) => {
        e.preventDefault();
        this.props.reinitiateFailedCrawlersRequest({
            file: this.state.uploadedFile,
        })
        this.props.preloading(true);
    }

    toggleCrawlerStatusReportModal = () => {
        this.setState((prevState) => ({
            crawlerStatusModal: !prevState.crawlerStatusModal,
            fromDate: null,
            toDate: null,
        }));
    }

    toggleDayOfMonthModel = () => {
        this.setDayOfMonthValues(this.state.dayOfMonth);
        this.setState((prevState) => ({
            dayOfMonthModal: !prevState.dayOfMonthModal,
         
        }))
    }

    actionsToggle = () => {
        this.setState((prevState) => ({
            actionsDropdown: !prevState.actionsDropdown,
        }));
    }

    

    popovertoggle = () => {
        this.setState((prevState) => ({      
          popoverOpen: !prevState.popoverOpen
        }));
        this.formOneElement.current.handleFilterOnPageRefreshOrBackButton(getSecondaryUrlFilter(this.props.location.search));
    }

    caseListFilterCallBack = (productType, caseType, data, date, popoverFlag, filterResetFlag) => {
        if (this.state.selectedCorporate){
            const tempAppliedFilters = setAppliedFilters(this.state.selectedCorporate, productType, caseType, data, date);  
            const requestBody = setRequestBody(this.state.selectedCorporate, productType, caseType, date);
            this.props.fetchFilteredEwsCounterpartiesRequest(requestBody);

            this.setState({
                selectedCorporate: this.state.selectedCorporate,
                counterparties: this.props.counterparties,
                updatedCounterparties: [],
                toDate: date? date.toDate : null,
                fromDate: date? date.fromDate: null,
                productType: productType,
                caseType: caseType,
                updateFlag: true,
                loading: true,
                appliedFilters: tempAppliedFilters,
                clearAllButton: (tempAppliedFilters.length > 0) ? <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button> : null,
            });
            
            if (popoverFlag && !filterResetFlag) {
                const url = createSecondaryFilterUrl(this.state.selectedCorporate, productType, caseType, date);
                this.props.history.push(`?${url}`);      
                this.popovertoggle();                    
            }else if(!popoverFlag && !filterResetFlag){
                const url = createSecondaryFilterUrl(this.state.selectedCorporate, productType, caseType, date);
                this.props.history.push(`?${url}`);
            }
            else if(popoverFlag && filterResetFlag){
                this.props.history.push(`?${""}`);
            }
        } else {
            displayErrorMessage("Please Select Corporate!!")
        }          
        
    }

    handleRemoveFilter = (removeFilter) => {
        let { toDate, fromDate, searchCorporate } = this.state;
        let removeEntityFilterList = [...searchCorporate];
        const removeFilterList = deleteAppliedFilters(removeFilter, this.state.appliedFilters);
    
        let clearButton = removeFilterList.length > 0 ? (
            <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>
                Clear All
            </Button>
        ) : null;
    
        if (removeFilter.value === constant.DATE_TEXT) {
            fromDate = null;
            toDate = null;
        } else {
            removeEntityFilterList = deleteEntityFilter(this.state.searchCorporate, removeFilter);
        }
    
        let updatedState = {
            appliedFilters: removeFilterList,
            clearAllButton: clearButton,
            searchCorporate: removeEntityFilterList,
            fromDate: fromDate,
            toDate: toDate,
            loading: true,
        };
    
        if (removeFilter.value === 'productType') {
            updatedState.productType = undefined;
        }
        if (removeFilter.value === 'caseType') {
            updatedState.caseType = undefined;
        }
    
        this.setState(updatedState, () => {
            const date = { toDate, fromDate };
            const tempRequestBody = setRequestBody(
                this.state.productType,
                this.state.caseType,
                removeEntityFilterList,
                date,
                this.state.searchText,
                this.state.selectedSearchType
            );
    
            const url = createSecondaryFilterUrl(
                this.state.productType,
                this.state.caseType,
                date,
                removeEntityFilterList
            );
            this.props.history.push(`?${url}`);
    
            this.formOneElement.current.handleRemoveFilter(removeFilter);
        });
    }    
      handleClearAll = () => {
        this.setState({
          productType: null,
          caseType: null,
          appliedFilters: [],
          toDate: null,
          fromDate: null,
          clearAllButton: null,
          loading: true
        }, () => {
          const date = {
            toDate: this.state.toDate,
            fromDate: this.state.fromDate
          }
          const tempRequestBody = setRequestBody(this.state.productType, this.state.caseType, date, this.state.searchText, this.state.selectedSearchType)
          this.props.history.push(`?${""}`);
        })
        this.formOneElement.current.handleResetDateFilter() // Reset popover filter
    }

    onDOMValueChange = (e) => {
        const { name, value } = e.target;
        const updatedDayOfMonth = { ...this.state.dayOfMonth };
    
        switch (name) {
            case 'gst-start-day':
                updatedDayOfMonth.gst = value;
                break;
            case 'mca-start-day':
                updatedDayOfMonth.mca = value;
                break;
            case 'epf-start-day':
                updatedDayOfMonth.epf = value;
                break;
            case 'ratings-start-day':
                updatedDayOfMonth.ratings = value;
                break;
            case 'legal-start-day':
                updatedDayOfMonth.legal = value;
                break;
            case 'news-start-day':
                updatedDayOfMonth.news = value;
                break;
            default:
                break;
        }
    
        this.setState({
            dayOfMonth: updatedDayOfMonth
        });
    }    

    setDayOfMonthValues = (dayOfMonth) => {
        if (dayOfMonth.gst) {
            this.props.change('gst-start-day', dayOfMonth.gst);
        }
        if (dayOfMonth.mca) {
            this.props.change('mca-start-day', dayOfMonth.mca);
        }
        if (dayOfMonth.epf) {
            this.props.change('epf-start-day', dayOfMonth.epf);
        }
        if (dayOfMonth.ratings) {
            this.props.change('ratings-start-day', dayOfMonth.ratings);
        }
        if (dayOfMonth.legal) {
            this.props.change('legal-start-day', dayOfMonth.legal);
        }
        if (dayOfMonth.news) {
            this.props.change('news-start-day', dayOfMonth.news);
        }
    }
    submitCrawlerStartDay = (e) => {
        if(this.validateDayOfMonth(this.state.dayOfMonth)){
            this.props.updateDayOfMonthRequest(this.state.dayOfMonth);
            this.toggleDayOfMonthModel();
            displaySuccessMessage("Day of Month updated Successfully!!")
        }else{
            this.displayErrorMessage("Please enter valid day of month!");
        }
    }
   
   validateDayOfMonth = (dayOfMonth) => {
        let isValid = true;
        Object.keys(dayOfMonth).forEach(function(key) {
            if(key !== 'id'){
                if(!(dayOfMonth[key] && dayOfMonth[key] > 0 && dayOfMonth[key] < 32)){
                    isValid = false;
                }
            }
        });
        return isValid;
   }

   toggleTodoOptinSchedulerModal = () => {
        this.setState((prevState) => ({
            todoOptinSchedulerModal: !prevState.todoOptinSchedulerModal,
        }))
    }

    handleTodoOptinScheduler = () => {
        this.props.ewsTodoOptinSchedulerRequest();
        this.setState((prevState) => ({
            todoOptinSchedulerModal: !prevState.todoOptinSchedulerModal,
        }));
        displaySuccessMessage("TODO optin scheduler Initiated Successfully!!");
    }
   
    render() {
        return (
            <Col>
                <div>                
                    <Row className="mb-3 align-items-center">
                        <Col sm="4">
                            <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Select Corporate</span>
                        </Col>
                        <Col sm="7">
                            <Select
                                value={this.state.selectedCorporate}
                                onChange={this.handleCorporateChange}
                                options={this.state.corporates}
                                isClearable={false} />
                        </Col>
                        <Col sm="3">
                            <Button disabled={this.state.updatedCounterparties.length === 0} color="success" onClick={this.proceedEWSOptIn}>Proceed</Button>
                        </Col>
                        <Col sm="3">
                            <Dropdown isOpen={this.state.actionsDropdown} toggle={this.actionsToggle}>
                                <DropdownToggle>
                                    Actions  <i className="fa fa-caret-down"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem 
                                        onClick={this.openPlanModel}>
                                        Manage Plans
                                    </DropdownItem>
                                    <div title={!this.state.selectedCorporate ? 'Please select corporate!' :''} >
                                        <DropdownItem                                         
                                            disabled={!this.state.selectedCorporate} 
                                            onClick={this.toggleCPUploadModal}>
                                            Upload Counterparties
                                        </DropdownItem>
                                    </div>                                    
                                    <div title={!this.state.selectedCorporate ? 'Please select corporate!' :''} >
                                        <DropdownItem 
                                            disabled={!this.state.selectedCorporate} 
                                            onClick={this.toggleCrawlerStatusReportModal}>
                                            Crawler Status Report
                                        </DropdownItem>
                                    </div>
                                    <div title={!this.state.selectedCorporate ? 'Please select corporate!' :''} >
                                        <DropdownItem 
                                            title={'Please select corporate!'}
                                            disabled={!this.state.selectedCorporate} 
                                            onClick={this.toggleReinitiateCrawlerModal}>
                                            Re-Initiate Crawlers
                                        </DropdownItem>
                                    </div>
                                    <DropdownItem  
                                        onClick={this.toggleDayOfMonthModel}> 
                                        Update Day of Month
                                    </DropdownItem>
                                    <DropdownItem 
                                        onClick={this.toggleEWSReportDataUploadModal}>
                                        Upload EWS Report Data
                                    </DropdownItem>
                                    <DropdownItem 
                                        onClick={this.toggleTodoOptinSchedulerModal}>
                                        Run TODO Optin Scheduler
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        <Col sm="3">
                            <Button color="success" onClick={this.runEWS}>Run EWS</Button>
                        </Col>
                        <Col sm='2'>
                            <div className="filter-wrapper ml-auto">
                            <div>
                                <Button id="Popover1" className={this.state.popoverOpen ? 'btn-filter btn-icon filter-popover-open' : 'btn-filter btn-icon'} outline size="sm" color="primary" onClick={this.popovertoggle}>
                                <i className="icon-filter"></i>
                                </Button>
                                {/*<Button color="primary" outline size="sm" className="ml-3 d-sm-none">Applied Filters</Button>*/}
                            </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Row>
                <div className={this.state.popoverOpen ? "position-absolute filter-popover case-filter-popover d-block bg-light p-4" : "position-absolute filter-popover d-none p-3"}>
                    <FilterFormTypeTwo 
                    updateFlag={this.state.updateFlag} 
                    multiselectTitle='Corporate Name' 
                    correspondentList={this.props.corporateNameList} 
                    dateFilterType='Created On' 
                    hideFilterCallback={this.popovertoggle} 
                    filterCallback={this.caseListFilterCallBack} 
                    dateFilters={{ toDate: this.state.toDate, fromDate: this.state.fromDate }}
                    selectedEntity={this.state.searchCorporate} 
                    productTypeFlag = {true} 
                    caseTypeFlag = {true} 
                    ref={this.formOneElement}/>
                </div>
                <div className="row no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className={this.state.appliedFilters.length>0?"filter-title col-sm-3 pr-0":'hidden'}>Applied Filters :</Label>
                        <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                            {this.state.appliedFilters.map(p => {
                            return (
                                <span key={p.value} className="filter-item d-flex align-items-center mr-2 mb-2">
                                {decodeURIComponent(p.label)} <i className="icon-close" onClick={() => this.handleRemoveFilter(p)}></i>
                                </span>
                            )
                            })}
                            {this.state.clearAllButton}
                        </div>
                </div>
                    <div className="col">
                        <EWSCounterpartyTable
                            tasks={this.state.counterparties}
                            loading={this.state.loading}
                            updateCounterparties={this.updateChangedEWSCounterparties}
                            onMasterPlanChange={this.updateSelectedCPsOnMasterPlanChange}
                            ewsPlans={this.state.ewsPlans}
                            selectedData={this.state.selectedCorporate}
                        />
                    </div>
                </Row>
                <Modal show={this.state.planModal} className='Large-Modal shadow-none plan-modal' >
                    {this.state.planModalBody}
                </Modal>

                {/* Counterparty upload modal */}
                <Modal show={this.state.cpUploadModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader>Counterparty Upload</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={15}>
                                <Input id="upload-cp" type="file" onChange={(e) => this.uploadFile(e)} className="btn position-relative" style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button style={{ float: 'right', width: '200px' }} disabled={!this.state.uploadedFile} color="primary" onClick={e => this.handleCounterpartyUpload(e)}>Upload Counterparties</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button style={{ float: 'right', width: '200px' }} color="primary" onClick={this.downloadCPUploadTemplate}>Download Template</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleCPUploadModal}>Close</Button>
                    </ModalFooter>
                </Modal>

                {/* EWS Report data upload modal */}
                <Modal show={this.state.ewsDataUploadModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader>EWS Report Data Upload</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={15}>
                                <Input id="upload-ews-report-data" type="file" onChange={(e) => this.uploadFile(e)} className="btn position-relative" style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                <Button style={{ float: 'right', width: '210px' }} disabled={!this.state.uploadedFile} color="primary" onClick={e => this.handleEWSReportDataUpload(e)}>Upload EWS Report Data</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button style={{ float: 'right', width: '210px' }} color="primary" onClick={this.downloadEWSReportDataUploadTemplate}>Download Template</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleEWSReportDataUploadModal}>Close</Button>
                    </ModalFooter>
                </Modal>

                {/* Crawler status report modal */}
                <Modal show={this.state.crawlerStatusModal} className='Modal shadow-none crawler-status-modal' >
                    <ModalHeader>Crawler Status Report</ModalHeader>
                    <ModalBody style={{ paddingBottom: "190px" }}>
                        <Row>
                            <Col>
                                From Date <DatePicker className="form-control" selected={this.state.fromDate} onChange={this.handleFromDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                            </Col>
                            <Col >
                                To Date <DatePicker className="form-control" selected={this.state.toDate} onChange={this.handleToDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-yyyy" maxDate={moment()} />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleCrawlerStatusReportModal}>Close</Button>
                        <Button color="primary" disabled={!this.state.fromDate || !this.state.toDate} onClick={this.downloadCrawlerStatusReport}>Download Report</Button>
                    </ModalFooter>
                </Modal>

                {/* Re-Initiate Crawler Model */}
                <Modal show={this.state.reinitiateCrawlerModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader>Reinitiate Failed Crawlers</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={16}>
                                <Input id="reinitiate-crawlers" type="file" onChange={(e) => this.uploadFile(e)} className="btn position-relative" style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col >
                                <Button disabled={!this.state.uploadedFile} color="primary" onClick={e => this.handleReinitiateCrawlers(e)}>Reinitiate Crawlers</Button>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleReinitiateCrawlerModal}>Close</Button>
                    </ModalFooter>
                </Modal>

                {/* {Crawler day of Month} */}                
                <Modal show={this.state.dayOfMonthModal} className='Modal shadow-none dom-modal' >
                    <ModalHeader>Select Day to Start Crawler</ModalHeader>
                    <ModalBody>
                        <form className="modal-content shadow-none border-0" >
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>GST Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`gst-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.gst ? this.state.dayOfMonth.gst: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>MCA Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`mca-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.mca ? this.state.dayOfMonth.mca: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>EPF Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`epf-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.epf ? this.state.dayOfMonth.epf: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>Ratings Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`ratings-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.ratings ? this.state.dayOfMonth.ratings: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>Legal Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`legal-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.legal ? this.state.dayOfMonth.legal: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-18">
                                <label className='crawler-label'>News Crawler: </label>
                            </div>
                            <div className="col-2">
                                <Field type="number"
                                    
                                    name={`news-start-day`}
                                    component="input"
                                    props= {this.state.dayOfMonth}
                                    value= {this.state.dayOfMonth && this.state.dayOfMonth.news ? this.state.dayOfMonth.news: ""}
                                    onChange={(e) => this.onDOMValueChange(e)}
                                    placeholder= "Pick a day"
                                    className="p-2 radius-5 border risk-grade-input"
                                    min="1"
                                    max="31" />
                            </div>
                        </Row>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleDayOfMonthModel}>Close</Button>
                        <Button color="primary" onClick={this.submitCrawlerStartDay}>Submit</Button>
                    </ModalFooter>
                </Modal>

                {/* TODO Optin Scheduler Model */}
                <Modal show={this.state.todoOptinSchedulerModal} className='Modal shadow-none cp-upload-modal' >
                    <ModalHeader className="label-text-center">TODO Optin Scheduler</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Label className="label-text-center">Do You Wish To Proceed With Running TODO Optin Scheduler ? </Label>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleTodoOptinSchedulerModal}>Close</Button>
                        <Button color="primary" onClick={this.handleTodoOptinScheduler}>Confirm</Button>
                    </ModalFooter>
                </Modal>
            </Col>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    corporateNameList: state.cases.corporateNameList,
    counterpartyList: state.ews.ewsCounterparties,
    ewsOptInResponse: state.ews.ewsOptinResponse,
    ewsPlansList: state.ews.ewsPlanList,
    cpUploadTemplate: state.ews.cpUploadTempate,
    cpUploadResponse: state.ews.cpUploadResponse,
    addPlanResponse: state.ews.addPlanResponse,
    crawlerStatusResponse: state.ews.crawlerStatusResponse,
    reinitiateCrawlerResponse: state.ews.reinitiateCrawlerResponse,
    dayOfMonth: state.ews.dayOfMonth,
    getDayOfMonthResponse: state.ews.getDayOfMonthResponse,
    runEWSResponse: state.ews.runEWSResponse,
    ewsDataUploadTemplate: state.ews.ewsDataUploadTemplate,
    ewsDataUploadResponse: state.ews.ewsDataUploadResponse,
});

const mapDispatchToProps = (dispatch) => ({
    getCorporateName: () => { dispatch(getCorporateName()) },
    fetchEwsCounterpartiesRequest: (data) => { dispatch(fetchEwsCounterpartiesRequest(data)) },
    fetchFilteredEwsCounterpartiesRequest: (data) => { dispatch(fetchFilteredEwsCounterpartiesRequest(data)) },
    optInForEwsRequest: (data) => { dispatch(optInForEwsRequest(data)) },
    ewsPlanListRequest: () => { dispatch(ewsPlanListRequest()) },
    counterpartyUploadTemplateRequest: () => { dispatch(counterpartyUploadTemplateRequest()) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    counterpartyUploadRequest: (data) => { dispatch(counterpartyUploadRequest(data)) },
    addEwsPlanRequest: (data) => { dispatch(addEwsPlanRequest(data)) },
    fetchCrawlerStatusReportRequest: (data) => { dispatch(fetchCrawlerStatusReportRequest(data)) },
    reinitiateFailedCrawlersRequest: (data) => { dispatch(reinitiateFailedCrawlersRequest(data)) },
    getDayOfMonthRequest: () => { dispatch(getDayOfMonthRequest()) },
    runEWSRequest: () => { dispatch(runEWSRequest()) },
    updateDayOfMonthRequest: (data) => { dispatch(updateDayOfMonthRequest(data)) },
    updateDayOfMonthRequest: (data) => { dispatch(updateDayOfMonthRequest(data)) },
    ewsReportDataUploadTemplateRequest: () => {dispatch(ewsReportDataUploadTemplateRequest())},
    ewsReportDataUploadRequest: (data) => {dispatch(ewsReportDataUploadRequest(data))},
    ewsTodoOptinSchedulerRequest: () => {dispatch(ewsTodoOptinSchedulerRequest())},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({ form: 'EarlyWarningSystem',enableReinitialize: true })(EarlyWarningSystem));
